// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1zdhe","itemTitle":"ClientEmergencyInfo_itemTitle__2kQpk","itemText":"ClientEmergencyInfo_itemText__3uCa_"};